async function generateHashFromObject (tohash) {
  const json = JSON.stringify(tohash)
  let h = 0
  for (let i = 0; i < json.length; i++) { h = Math.imul(31, h) + json.charCodeAt(i) | 0 }
  return h
}

export default generateHashFromObject
